import script from "./TheHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./TheHeader.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__
import QHeader from 'quasar/src/components/header/QHeader.js';
import QToolbar from 'quasar/src/components/toolbar/QToolbar.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QToolbarTitle from 'quasar/src/components/toolbar/QToolbarTitle.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QHeader,QToolbar,QImg,QToolbarTitle,QBtn});
